import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { CHEVRON_LEFT_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ChevronLeftIcon = (props: IconGlyphProps) => <Icon {...props} glyph={CHEVRON_LEFT_GLYPH} />;
